// Runtime arrays strictly matching the Inventory string unions
// [2026-02-06] BR-25: Added "Any Condition" for WTB broadcasts
export const CONDITION_OPTIONS = [
  "Any Condition", // BR-25: WTB only - matches any condition when matching
  "NEW Retail",
  "New Bulk",
  "Refurbished",
  "Used",
  "AS-IS",
] as const;

export const CATEGORY_OPTIONS = [
  "Drones/UAV",
  "Motors & Props",
  "Cameras & Gimbals",
  "Batteries",
  "GCS – Ground Control Systems",
  "Storage",
  "Components",
  "Robotics",
  "Software",
  "C-UAS",
  "Services",
  "Safety",
  "Other",
] as const;
